import { FormGroup } from '@angular/forms';
import { createAction, props } from '@ngrx/store';

export const loadSettings = createAction(
  '[Settings] Load Settings'
);

export const loadSettingsSuccess = createAction(
  '[Settings] Load Settings Success',
  props<any>()
);

export const loadSettingssFailure = createAction(
  '[Settings] Load Settings Failure',
  props<{ error: any }>()
);

export const submitSettings = createAction(
  '[Settings] Submit Settings',
  props<{form: any }>()
);

export const submitSettingsSuccess = createAction(
  '[Settings] Submit Settings Success',
  props<any>()
);

export const submitSettingssFailure = createAction(
  '[Settings] Submit Settings Failure',
  props<{ error: any }>()
);
